module.exports = __webpack_public_path__ + "img/netral-face-expression.de3b7b3c.png";